<template>
  <div class="inline-filters" v-if="!isLoading">
    <div
      v-for="(group, groupKey, index) in groupedAvailableFilters"
      :key="index"
      class="d-flex align-baseline flex-wrap"
    >
      <strong>{{ groupKey | startCase }}</strong>
      <div
        class="mb-1"
        v-for="(filterOptions, filterKey, index) in group"
        :key="index"
      >
        <InlineFilter
          v-if="size(filterOptions)"
          :label="getFilterLabel(filterKey)"
          :filters="filters[filterKey]"
          :options="filterOptions"
          @clear="handleClear(filterKey)"
          :isDate="getFilterType(filterKey) === 'date'"
          :isText="getFilterType(filterKey) === 'number'"
        >
          <DatePicker
            v-model="filters[filterKey]"
            v-if="getFilterType(filterKey) === 'date'"
            :inputValue="filters[filterKey]"
            @updatedDate="value => updateFilterFor(filterKey, value)"
            label=""
          />
          <v-text-field
            v-else-if="getFilterType(filterKey) === 'number'"
            prepend-inner-icon="mdi-currency-gbp"
            type="number"
            min="0"
            :aria-label="getFilterLabel(filterKey)"
            v-model="filters[filterKey]"
            @change="saveChanges"
            hide-details
          />

          <div v-else>
            <FilterCheckbox
              :options="filterOptions"
              :selectedValues="filters[filterKey]"
              @change="values => updateFilterFor(filterKey, values)"
            />
          </div>
        </InlineFilter>
      </div>
      <span
        class="mr-2 grey--text"
        v-if="index !== size(groupedAvailableFilters) - 1"
      >
        |
      </span>
    </div>
  </div>
</template>

<script>
import { isEmpty, omitBy, size } from "lodash";
import { getGroupedFilters } from "@/utils/workers";
import { WORKER_FILTERS } from "@/constants/workers";
import DatePicker from "@/components/common/DatePicker";
import InlineFilter from "@/components/common/InlineFilter";
import FilterCheckbox from "@/components/common/FilterCheckbox";

export default {
  name: "WorkerListFilter",
  components: { InlineFilter, DatePicker, FilterCheckbox },
  props: {
    isLoading: Boolean,
    availableFilters: Object,
    outerSelectedFilters: Object
  },
  data() {
    return {
      filters: Object.assign({}, this.outerSelectedFilters)
    };
  },
  computed: {
    groupedAvailableFilters() {
      return getGroupedFilters(this.availableFilters);
    }
  },
  methods: {
    clearFilters() {
      this.$emit("onClearFilters");
    },
    saveChanges() {
      const formattedFilters = omitBy(this.filters, isEmpty);
      this.$emit("filter", formattedFilters);
    },
    updateFilterFor(key, value) {
      this.filters = { ...this.filters, [key]: value };
      this.saveChanges();
    },
    handleClear(key) {
      this.filters[key] = [];
      this.saveChanges();
    },
    getFilterLabel(key) {
      return WORKER_FILTERS[key].label;
    },
    getFilterType(key) {
      return WORKER_FILTERS[key].type;
    },
    size
  },
  watch: {
    outerSelectedFilters(newValue) {
      if (isEmpty(newValue)) {
        this.filters = {};
      }
    }
  }
};
</script>

<style lang="scss">
.worker-filters {
  .v-input.v-text-field {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
